<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <!--vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="Add()">
                <span class="flex items-center">
                  <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Add</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="Delete()">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>>

            </vs-dropdown-menu>
          </!--vs-dropdown-->
      </div>


      <!-- AgGrid Table floatingFilter="true"-->
      <!--:onGridReady="onGridReady" -->
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :pinnedBottomRowData="pinnedBottomRowData"
        >
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
// Store Module
const axios = require('axios').default;
// Cell Renderer
import moment from "moment-timezone";
import firebase from '@/services/saleData'
import 'firebase/database'
import 'firebase/firestore'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: `userManagement/getField`,
  mutationType: `userManagement/updateField`,
});
export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
  },
  // beforeMount() {
  //   this.getRowStyle = (params) => {
  //     if (params.node.rowPinned) {
  //       return { 'font-weight': 'bold' };
  //     }
  //   };
  //   this.pinnedBottomRowData = this.createData(1, 'Bottom');
  // },
  data () {
    return {
      userId:'',
      selected: '',
      selectedmenu: '',
      adminsend:'',
      songkran:'',
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      roleOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],

      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' }
      ],

      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' }
      ],

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        suppressContextMenu:true,
        onCellEditingStopped: (event) => {
          if(event.column.colId === 'firstname' || event.column.colId === 'lastname' || event.column.colId === 'bank' || event.column.colId === 'account_no' || event.column.colId === 'calculate' || event.column.colId === 'ball'){
            this.$store.dispatch('userManagement/updateFieldUsers',{key:event.data.key,value:event.value,column:event.column.colId}).catch(err => { console.error(err) })
          }
        }
      },
      pinnedBottomRowData: null,
      defaultColDef: {
        flex: 1,
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 150,
          filter: true,
        },
        {
          headerName: 'TEXT',
          field: 'text',
          width: 650,
          filter: true,
        },
      ],

      // Cell Renderer Components
     
    }
  },
  watch: {
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    ...mapFields([
        'popup',
        'popup2'
    ]),
    userOption(){
      return this.$store.state.userManagement.userOption
    },
    usersData () {
      return this.$store.state.statementManagement.pushbullet
    },
    userSelect () {
      return this.$store.state.userManagement.user_select
    },
    userSelect2 () {
      return this.$store.state.userManagement.user_select2
    },
    paginationPageSize () {
      //if (this.gridApi) return this.gridApi.paginationGetPageSize() else
      return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    onGridReady(params){
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        window.onresize = () => {
            this.gridApi.sizeColumnsToFit();
        }
    },
    confirmDeleteRecord (data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${data}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    async deleteRecord () {
      for(const data of this.gridApi.getSelectedRows()){
        const emailKey = data.email.trim().replace(/\./g, '||');
        await firebase.database().ref().child(`users/${emailKey}`).remove();
      }
      this.showDeleteSuccess()
      this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    Add(){
      this.$router.push('/management/user/form')
    },
    Delete(){
      if(this.gridApi.getSelectedRows().length){
        let text = ''
        for(const data of this.gridApi.getSelectedRows()){
          text += (text)?', '+data.firstname:data.firstname
        }
        this.confirmDeleteRecord(text);
      }
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    updateUser(){
      if(this.songkran){
        axios({
          method: "get",
          url: "https://api.ufaeasy888.com/songkran/"+this.userSelect.userId,
        });
        this.songkran = '';
      }else
      if(this.adminsend){
        axios({
          method: "get",
          url: "https://api.ufaeasy888.com/adminsend/"+this.userSelect.userId,
        });
        this.selectedmenu = '';
        this.adminsend = '';
      }else
      if(this.selectedmenu){
        axios({
          method: "get",
          url: "https://api.ufaeasy888.com/genrichmenu/"+this.userSelect.userId,
        });
        this.selectedmenu = '';
      }else{
        axios({
          method: "post",
          url: "https://api.ufaeasy888.com/resetpassword",
          data: {
            id: this.userSelect.key,
          }
        });
        this.selected = '';
      }
      /*.then(async response => {
       
      }).catch(function() {
        
      });*/
       this.$store.commit('userManagement/SET_POPUP', false);
    },
    async updateUser2(){
      if(this.userSelect2 && this.userId.userId){
        const users2 = (await firebase.database().ref(`users`).orderByChild('userId').equalTo(this.userId.userId).once('value')).val();
        const key = Object.keys(users2)[0];
        firebase.firestore().collection('friends').doc(this.userId.userId).set({
          createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          userId:this.userSelect2.userId,
          friendId:this.userId.userId,
        });
        firebase.database().ref(`users/${key}`).update({
          userFriendId:this.userSelect2.userId
        }).then(()=>{
          this.$vs.notify({
            color: 'success',
            title: 'Add Friend',
            text: 'The selected user was successfully'
          })
        });
      }
      // firebase.firestore().collection("sharefriend").add({
      //   userId:this.userSelect2.userId,
      //   friendId:this.userId.userId,
      //   createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      // }).then((query)=>{
      //   axios({
      //     method: "get",
      //     url: "https://api.ufaeasy888.com/sharefriend/"+query.id,
      //   });
      // });
       this.$store.commit('userManagement/SET_POPUP2', false);
    },
    closePopup(){
       this.$store.commit('userManagement/SET_POPUP', false);
    },
    closePopup2(){
       this.$store.commit('userManagement/SET_POPUP2', false);
    },
    createData(count, prefix) {
      var result = [];
      for (var i = 0; i < count; i++) {
        result.push({
          codeold: prefix + ' Age ' + i,
          ip: prefix + ' Country ' + i,
          firstname: prefix + ' Year ' + i,
          lastname: prefix + ' Date ' + i,
          bank: prefix + ' Date ' + i,
          account_no: prefix + ' Sport ' + i,
          coins: prefix + ' Sport ' + i,
          userFriendCode: prefix + ' Sport ' + i,
          createdate: prefix + ' Sport ' + i,
          lastlogin: prefix + ' Sport ' + i,
          ball: prefix + ' Sport ' + i,
          calculate: prefix + ' Sport ' + i,
          transactions: null,
        });
      }
      return result;
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if(window.innerWidth>1000)
    setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
